<template>
  <div class="bg-white p-3 shadow">
    <h4 class="text-center" v-t="`post.filter_category.title`"></h4>
    <hr>

    <m-category-wrapper>
      <template v-slot="{categories,flatCategories,setLinkType,clearRouter}">
        <div>
          <m-a :href="clearRouter('blog')" @click="$emit('category',null)">
            <span class="m-1 rounded-pill btn-primary btn btn-sm " v-t="`post.filter_category.first_item`"> </span>
          </m-a>
          <m-a v-for="category in categoryShape(categories,linkType)" @click="$emit('category',category)" :key="category.id"
               :href="setLinkType(category,linkType)">
            <span class="m-1 rounded-pill btn-primary btn btn-sm ">{{ category.name }}</span>
          </m-a>
        </div>
      </template>

    </m-category-wrapper>

  </div>
</template>

<script>
import {categoryPanelProps} from './CategoryPanelProps'
import {categoryMethods} from '../CategoriesMethods'
import mCategoryWrapper from '../../Wrappers/CategoryWrapper'
import mA from '../../Tags/A'

export default {
  name: "CategoriesPanel300",
  components: {mCategoryWrapper, mA},
  props: categoryPanelProps,
  methods: categoryMethods,
}
</script>

<style scoped>

</style>